import { useQuery } from '@tanstack/react-query';
import { buildApiUrl } from '../lib/apiBase';

export interface ToolReadinessAction {
  key: string;
  label: string;
  url: string;
  isPrimary: boolean;
}

export interface ToolReadinessDto {
  isAuthenticated: boolean;
  hasTenant: boolean;
  hasGitHubInstallation: boolean;
  hasRepoAccess: boolean;
  isReady: boolean;
  actions: ToolReadinessAction[];
}

async function fetchToolReadiness(toolKey: string): Promise<ToolReadinessDto> {
  const response = await fetch(`${buildApiUrl('/api/v1/tools/readiness')}?toolKey=${encodeURIComponent(toolKey)}`, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch tool readiness');
  }

  return response.json();
}

export function useToolReadiness(toolKey: string) {
  return useQuery({
    queryKey: ['tool-readiness', toolKey],
    queryFn: () => fetchToolReadiness(toolKey),
    staleTime: 30000, // 30 seconds
    retry: 1,
  });
}
